(function (root, factory) {
  var api = factory(root, root.ElazComboUtils);

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  root.ElazComboCart = api;
  api.install();
}(typeof window !== 'undefined' ? window : globalThis, function (root, utils) {
  'use strict';

  var REMOVE_SELECTOR = '[data-combo-remove]';
  var ITEM_SELECTOR = '[data-combo-instance-id]';
  var DEFAULT_ERROR_MESSAGE = 'Unable to remove this combo. Please try again.';
  var removalQueue = Promise.resolve();

  function isComboInstanceId(value) {
    return utils && typeof utils.isComboInstanceId === 'function'
      ? utils.isComboInstanceId(value)
      : value !== null && value !== undefined && String(value).trim() !== '';
  }

  function cartJsUrl() {
    var routes = root.routes || {};
    var rootUrl = routes.root_url || '/';

    return rootUrl.replace(/\/?$/, '/') + 'cart.js';
  }

  function controlsForInstance(instanceId) {
    if (!root.document || !root.document.querySelectorAll) {
      return [];
    }

    return Array.prototype.filter.call(root.document.querySelectorAll(REMOVE_SELECTOR), function (control) {
      return control && control.dataset && control.dataset.comboInstanceId === instanceId;
    });
  }

  function itemsForInstance(instanceId) {
    if (!root.document || !root.document.querySelectorAll) {
      return [];
    }

    return Array.prototype.filter.call(root.document.querySelectorAll(ITEM_SELECTOR), function (item) {
      return item && item.dataset && item.dataset.comboInstanceId === instanceId;
    });
  }

  function setInstanceBusy(container, instanceId, busy) {
    if (container && typeof container.setAttribute === 'function' && typeof container.removeAttribute === 'function') {
      if (busy) {
        container.setAttribute('aria-busy', 'true');
      } else {
        container.removeAttribute('aria-busy');
      }
    }

    controlsForInstance(instanceId).forEach(function (control) {
      control.disabled = busy;
    });

    itemsForInstance(instanceId).forEach(function (item) {
      if (busy) {
        item.setAttribute('aria-busy', 'true');
      } else {
        item.removeAttribute('aria-busy');
      }
    });
  }

  function isDrawer(container) {
    return container && String(container.tagName).toLowerCase() === 'cart-drawer';
  }

  function hasVisibleComboInstance(instanceId) {
    return controlsForInstance(instanceId).length > 0 || itemsForInstance(instanceId).length > 0;
  }

  function cartContainerType(container) {
    var tagName = container && container.tagName ? String(container.tagName).toLowerCase() : '';

    return tagName === 'cart-drawer' || tagName === 'cart-page' ? tagName : null;
  }

  function containerForElement(element) {
    return element && typeof element.closest === 'function'
      ? element.closest('cart-page, cart-drawer')
      : null;
  }

  function currentCartContainer(instanceId, preferredType) {
    var elements = controlsForInstance(instanceId).concat(itemsForInstance(instanceId));
    var fallback = null;

    for (var index = 0; index < elements.length; index += 1) {
      var container = containerForElement(elements[index]);
      var containerType = cartContainerType(container);

      if (!containerType) {
        continue;
      }
      if (containerType === preferredType) {
        return container;
      }
      fallback = fallback || container;
    }

    if (root.document && root.document.querySelectorAll) {
      var containers = root.document.querySelectorAll('cart-drawer, cart-page');
      for (var containerIndex = 0; containerIndex < containers.length; containerIndex += 1) {
        if (cartContainerType(containers[containerIndex]) === preferredType) {
          return containers[containerIndex];
        }
      }
    }

    return fallback;
  }

  function refreshDrawer(drawer) {
    return new Promise(function (resolve, reject) {
      var completed = false;
      var timeoutId;

      function cleanup() {
        clearTimeout(timeoutId);
        drawer.off('update-nodes', complete);
      }

      function complete() {
        if (completed) {
          return;
        }
        completed = true;
        cleanup();
        resolve();
      }

      function fail(error) {
        if (completed) {
          return;
        }
        completed = true;
        cleanup();
        reject(error);
      }

      if (typeof drawer.update !== 'function' || typeof drawer.on !== 'function' || typeof drawer.off !== 'function') {
        fail(new Error('cart drawer cannot refresh'));
        return;
      }

      drawer.on('update-nodes', complete);
      timeoutId = setTimeout(function () {
        fail(new Error('cart drawer update timed out'));
      }, 3000);

      try {
        var updateResult = drawer.update();
        if (updateResult && typeof updateResult.then === 'function') {
          updateResult.then(complete, fail);
        }
      } catch (error) {
        fail(error);
      }
    });
  }

  function reloadCartPage() {
    try {
      if (root.location && typeof root.location.reload === 'function') {
        root.location.reload();
        return true;
      }
    } catch (error) {
      return false;
    }

    return false;
  }

  function refreshCartContext(container, instanceId) {
    if (isDrawer(container)) {
      return refreshDrawer(container).then(function () {
        if (hasVisibleComboInstance(instanceId)) {
          reloadCartPage();
        }
      }, function () {
        reloadCartPage();
      });
    }

    reloadCartPage();
    return Promise.resolve();
  }

  function errorMessage() {
    var body = root.document && root.document.body;
    var message = body && body.dataset ? body.dataset.comboCartRemoveErrorMessage : null;

    return typeof message === 'string' && message.trim() !== '' ? message : DEFAULT_ERROR_MESSAGE;
  }

  function announceError() {
    var bodyElement = root.document && root.document.querySelector
      ? root.document.querySelector('body-element')
      : null;

    if (bodyElement && typeof bodyElement.showNotification === 'function') {
      bodyElement.showNotification(errorMessage(), 'warning');
      return;
    }

    if (!root.document || !root.document.createElement || !root.document.body) {
      return;
    }

    var alert = root.document.createElement('div');
    alert.setAttribute('role', 'alert');
    alert.setAttribute('aria-live', 'assertive');
    alert.textContent = errorMessage();
    root.document.body.appendChild(alert);
    var removalTimer = setTimeout(function () {
      if (typeof alert.remove === 'function') {
        alert.remove();
      }
    }, 5000);
    if (removalTimer && typeof removalTimer.unref === 'function') {
      removalTimer.unref();
    }
  }

  async function removeComboNow(request) {
    var instanceId = request && request.instanceId;
    var container = currentCartContainer(instanceId, request && request.containerType);

    if (!container || !isComboInstanceId(instanceId)) {
      return false;
    }

    instanceId = String(instanceId);
    setInstanceBusy(container, instanceId, true);

    try {
      var cartResponse = await root.fetch(cartJsUrl(), { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) {
        throw new Error('cart read failed');
      }

      var cart = await cartResponse.json();
      var updates = utils && typeof utils.comboRemovalUpdates === 'function'
        ? utils.comboRemovalUpdates(cart, instanceId)
        : {};

      if (Object.keys(updates).length) {
        var routes = root.routes || {};
        var updateResponse = await root.fetch(routes.cart_update_url, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates }),
        });
        if (!updateResponse.ok) {
          throw new Error('cart update failed');
        }
      }

      await refreshCartContext(container, instanceId);
      return true;
    } catch (error) {
      announceError();
      return false;
    } finally {
      setInstanceBusy(container, instanceId, false);
    }
  }

  function removeCombo(control) {
    var instanceId = control && control.dataset ? control.dataset.comboInstanceId : null;
    var containerType = cartContainerType(containerForElement(control));

    if (!isComboInstanceId(instanceId) || !containerType) {
      return Promise.resolve(false);
    }

    var request = {
      instanceId: String(instanceId),
      containerType: containerType,
    };
    var operation = function () {
      return removeComboNow(request);
    };
    var queuedRemoval = removalQueue.then(operation, operation);

    removalQueue = queuedRemoval.catch(function () {
      return undefined;
    });
    return queuedRemoval;
  }

  function install() {
    if (!root.document || !root.document.addEventListener || root.document.documentElement
      && root.document.documentElement.hasAttribute('data-combo-cart-installed')) {
      return;
    }

    if (root.document.documentElement) {
      root.document.documentElement.setAttribute('data-combo-cart-installed', 'true');
    }
    root.document.addEventListener('click', function (event) {
      var target = event.target;
      var control = target && target.closest ? target.closest(REMOVE_SELECTOR) : null;

      if (!control || control.disabled) {
        return;
      }
      event.preventDefault();
      removeCombo(control);
    });
  }

  return {
    cartJsUrl: cartJsUrl,
    controlsForInstance: controlsForInstance,
    hasVisibleComboInstance: hasVisibleComboInstance,
    currentCartContainer: currentCartContainer,
    setInstanceBusy: setInstanceBusy,
    refreshDrawer: refreshDrawer,
    removeCombo: removeCombo,
    install: install,
  };
}));
